"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _create = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/create"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _vue = _interopRequireDefault(require("vue"));

var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));

var _common = require("./common");

/** @module */
var UserState = /*#__PURE__*/function () {
  function UserState(user) {
    (0, _classCallCheck2.default)(this, UserState);
    this.nick = user.nick;
    this.host = user.host || '';
    this.username = user.username || '';
    this.realname = user.realname || '';
    this.modes = user.modes || '';
    this.away = user.away || '';
    this.colour = user.colour || '';
    this.account = user.account || '';
    this.buffers = (0, _create.default)(null);
    this.hasWhois = false;
    this.typingState = (0, _create.default)(null);
    this.avatar = user.avatar || {
      small: '',
      large: ''
    };
    this.ignore = false;

    _vue.default.observable(this); // Whois details are non-enumerable properties (vues $watch won't cover these properties)


    (0, _common.def)(this, 'actual_host', '', true);
    (0, _common.def)(this, 'helpop', '', true);
    (0, _common.def)(this, 'bot', '', true);
    (0, _common.def)(this, 'server', '', true);
    (0, _common.def)(this, 'server_info', '', true);
    (0, _common.def)(this, 'operator', '', true);
    (0, _common.def)(this, 'channels', '', true);
    (0, _common.def)(this, 'modes', '', true);
    (0, _common.def)(this, 'idle', '', true);
    (0, _common.def)(this, 'logon', '', true);
    (0, _common.def)(this, 'registered_nick', '', true);
    (0, _common.def)(this, 'secure', '', true);
    (0, _common.def)(this, 'special', '', true);
  }

  (0, _createClass2.default)(UserState, [{
    key: "getColour",
    value: function getColour() {
      if (!this.colour) {
        this.colour = TextFormatting.createNickColour(this.nick);
      } // default will use the themes default text colour


      return this.colour === 'default' ? '' : this.colour;
    }
  }, {
    key: "isAway",
    value: function isAway() {
      return !!this.away;
    }
  }, {
    key: "typingStatus",
    value: function typingStatus(_target, status) {
      var _this = this;

      var target = _target.toLowerCase();

      if (!status) {
        return this.typingState[target] || {
          status: ''
        };
      }

      var typing = this.typingState[target];

      if (!typing) {
        _vue.default.set(this.typingState, target, {
          started: 0,
          status: ''
        });

        typing = this.typingState[target];
      }

      if (typing.timeout) {
        clearTimeout(typing.timeout);
        typing.timeout = null;
      }

      if (status === 'done') {
        _vue.default.delete(this.typingState, target);

        return null;
      }

      typing.started = (0, _now.default)();
      typing.status = status; // Paused state gets a longer timeout as it's usually someone stopping typing
      // to think about their words

      var timeoutLen = status === 'paused' ? 30000 : 6000;
      typing.timeout = (0, _setTimeout2.default)(function () {
        return _this.typingStatus(target, 'done');
      }, timeoutLen);
      return typing;
    }
  }]);
  return UserState;
}();

exports.default = UserState;